import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListFlowsHistoryComponent } from './pages/list-flows-history/list-flows-history.component';

const routes: Routes = [
  {
    path: 'list',
    component: ListFlowsHistoryComponent,
    data: {
      firstBreadcrumb: {
        title: 'Con-Héctor',
        icon: '../../../assets/img/ConHector/Personaje_acciones/icon.png',
        url: '/',
      },
      title: 'Historial de Flows',
      url: 'flows-history/list',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlowsHistoryRoutingModule {}
